/** 限制并行 HTTP 数，避免 picker / binding refresh 一次打满连接池。 */
export const DEFAULT_HTTP_CONCURRENCY = 6

export async function runWithConcurrency(items, worker, limit = DEFAULT_HTTP_CONCURRENCY) {
  if (!Array.isArray(items) || !items.length) {
    return []
  }
  const poolSize = Math.max(1, Math.min(limit, items.length))
  const results = new Array(items.length)
  let nextIndex = 0

  async function drainQueue() {
    while (nextIndex < items.length) {
      const currentIndex = nextIndex
      nextIndex += 1
      results[currentIndex] = await worker(items[currentIndex], currentIndex)
    }
  }

  await Promise.all(Array.from({ length: poolSize }, () => drainQueue()))
  return results
}
